import type { FormInputType, FormValues } from '@/components/UI/Form/types'

export default function multiCheckboxHasUncheckedItems(
  inputs: FormInputType[],
  values: FormValues,
  inputName: string
): boolean {
  return inputs.some(input => {
    if (input.name === inputName && input.type === 'multi-checkbox') {
      const checkedValues = (
        Array.isArray(values[input.name]) ? values[input.name] : []
      ) as string[]

      return input.options.length !== checkedValues.length
    }

    return false
  })
}
